<template>
  <div class="inscription-list-page app-content">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.inscription.menu"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>
    
    <div class="app-content-create">
      <!-- Filter button -->
      <app-filter-button :active.sync="activeFilter" />
    </div>

    <!-- Filter form -->
    <app-inscription-list-filter  
      :activeFilter="activeFilter" 
      :manage="currentManage"
      style=""
      />

    <!-- Page -->
    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.inscription.list.title"></app-i18n>
      </h1>

      <app-inscription-list-toolbar :manage="currentManage"></app-inscription-list-toolbar>
      <app-inscription-list-table v-if="rows" :manage="currentManage"></app-inscription-list-table>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import InscriptionListFilter from '@modules/inscription/components/inscription-list-filter.vue';
import InscriptionListTable from '@modules/inscription/components/inscription-list-table.vue';
import InscriptionListToolbar from '@modules/inscription/components/inscription-list-toolbar.vue';

export default {
  name: 'app-inscription-list-page',
  computed: {
    ...mapGetters({
      currentManage: 'auth/manage/currentManage',
      rows: 'inscription/list/rows',
    }),
  },

  data() {
    return {
      activeFilter: false,
    };
  },

  methods: {
    ...mapActions({
      doChangeFilter: 'inscription/list/doChangeFilter',
    }),
  },

  components: {
    [InscriptionListFilter.name]: InscriptionListFilter,
    [InscriptionListTable.name]: InscriptionListTable,
    [InscriptionListToolbar.name]: InscriptionListToolbar,
  },
};
</script>

<style>
</style>
